module.exports = __webpack_public_path__ + "img/ic_foot_hight_7.8b0cdc2e.png";